import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { hideSaveCartModel, updateSavedCartTitle } from "../Actions/SaveCartPopUp.action";
import { translate } from "../Services/translation";
import { submitSaveCart, clearAllCart, setSelectedOrganizationUser } from "../Actions/Checkout.action";
class SaveCartPopUpContainer extends Component {
  constructor(props) {
    super(props);
  }
  c;
  getStatus() {
    return this.props["showSavecartPop"] == null ? false : this.props["showSavecartPop"];
  }
  getDefaultValue() {
    return this.props.payload["orderMarking"] == null ? "" : this.props.payload["orderMarking"] + " " + new Date().toISOString().slice(0, 10);
  }
  getSaveCartTitle() {
    return this.props.payload["saveCartTitle"] == "" ? this.getDefaultValue() : this.props.payload["saveCartTitle"];
  }

  render() {
    const { hideSaveCartModel, updateSaveCartValue, submitSaveCart, payload } = this.props;
    const { organizationUsers, selectedOrganizationUser } = payload;
    return (
      <Fragment>
        {this.getStatus() && (
          <Fragment>
            <div className="modal">
              <div className="modal__bg--overlay" onClick={() => hideSaveCartModel()}></div>
              <div className="modal__inner">
                <a className="modal__close" onClick={() => hideSaveCartModel()}>
                  <svg>
                    <use href="/ui/images/sprites/be-group.svg#close"></use>
                  </svg>
                </a>

                <div className="modal__icon">
                  <svg>
                    <use href="/ui/images/sprites/be-group.svg#thumbsup"></use>
                  </svg>
                </div>

                <div className="modal__text">
                  <p>{translate("checkout.savecart.title")}</p>
                  <h3>{translate("checkout.savecart.subtitle")}</h3>
                </div>

                <div className="modal__name-shoping">
                  <p>{translate("checkout.savecart.labelname")}</p>
                  <input
                    type="text"
                    placeholder={this.getSaveCartTitle()}
                    defaultValue={this.getSaveCartTitle()}
                    onChange={(event) => {
                      updateSaveCartValue(event.target.value);
                    }}
                  ></input>
                </div>
                {payload.isSalesRepresntative && (
                  <div>
                    <div>{payload.companyName}</div>
                    <div>{payload.companyAccountNumber}</div>
                  </div>
                )}

                {organizationUsers && organizationUsers.length > 0 && (
                  <div className="saved-cart-popup">
                    <select
                      className="form__input"
                      id="cartUserList"
                      value={selectedOrganizationUser}
                      onChange={(event) => {
                        this.props.setSelectedOrganizationUser(event.target.value);
                      }}
                    >
                      <option value="">{translate("checkout.savecart.viewfor")}</option>
                      {organizationUsers &&
                        organizationUsers.map((user) => (
                          <option value={user.userId ? user.userId : ""} key={user.userId}>
                            {user.firstName} {user.lastName}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                <div className="modal__actions">
                  <a className="button button--transparent" onClick={() => hideSaveCartModel()}>
                    {" "}
                    {translate("checkout.cart.popupclose")}
                  </a>
                  <a className={`button button${selectedOrganizationUser ? "--orange" : "--disabled"}`} onClick={() => submitSaveCart()}>
                    {" "}
                    {translate("checkout.savecart.savecartname")}
                  </a>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { checkout, savecartpopup } = state;
  return {
    ...checkout,
    ...savecartpopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideSaveCartModel: () => dispatch(hideSaveCartModel()),
    submitSaveCart: () => {
      dispatch(submitSaveCart());
      // dispatch(clearAllCart());
    },
    clearAllCart: () => {
      dispatch(clearAllCart());
    },
    updateSaveCartValue: (value) => {
      dispatch(updateSavedCartTitle(value));
    },
    setSelectedOrganizationUser: (userId) => dispatch(setSelectedOrganizationUser(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveCartPopUpContainer);
